import { render, staticRenderFns } from "./footer-modular.vue?vue&type=template&id=140a1e35&scoped=true&"
import script from "./footer-modular.vue?vue&type=script&lang=js&"
export * from "./footer-modular.vue?vue&type=script&lang=js&"
import style0 from "./footer-modular.vue?vue&type=style&index=0&id=140a1e35&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140a1e35",
  null
  
)

export default component.exports